import type { SchemaField, WalkFieldsOptions } from '@cli-types/core-engine/schema.js'
import { DEFAULT_WALK_OPTIONS } from '@cli-constants/schema.js'

export function walkFields(
  fields: SchemaField[],
  callback: (field: SchemaField, depth: number, parent?: SchemaField) => unknown,
  options: WalkFieldsOptions = DEFAULT_WALK_OPTIONS
): void {
  function walk(fieldsToWalk: SchemaField[], depth: number, parent?: SchemaField): boolean {
    for (const field of fieldsToWalk) {
      if (callback(field, depth, parent) === true) {
        return true
      }

      if (
        options.includeGroups &&
        (field.type === 'group' || field.type === 'section') &&
        field.fields
      ) {
        if (walk(field.fields, depth + 1, field)) return true
      }
      if (options.includeLists && field.type === 'list' && field.fields) {
        if (walk(field.fields, depth + 1, field)) return true
      }
      if (options.includeTabs && field.type === 'tabs' && field.tabs) {
        for (const tab of field.tabs) {
          if (tab.fields) {
            if (walk(tab.fields, depth + 1, field)) return true
          }
        }
      }
    }

    return false
  }

  walk(fields, 0)
}
